import React from 'react';
import { motion } from 'framer-motion';
import { Target, Zap, BarChart2, TrendingUp } from 'lucide-react';
const panelItems = [{
  icon: Target,
  label: 'Nuevos Leads',
  sublabel: 'Campañas Google Ads',
  value: '+287%'
}, {
  icon: Zap,
  label: 'Tareas Automatizadas',
  sublabel: 'Flujos con IA y CRM',
  value: '1.4K/mes'
}, {
  icon: TrendingUp,
  label: 'Retorno de Inversión',
  sublabel: 'ROAS promedio',
  value: '4.8X'
}];
const benefits = [{
  title: 'Más Clientes',
  description: 'Campañas diseñadas para generar oportunidades reales.',
  icon: Target
}, {
  title: 'Más Automatización',
  description: 'Menos trabajo manual y más eficiencia.',
  icon: Zap
}, {
  title: 'Más Datos',
  description: 'Decisiones basadas en métricas.',
  icon: BarChart2
}, {
  title: 'Más Rentabilidad',
  description: 'Optimización constante del retorno de inversión.',
  icon: TrendingUp
}];
export function Benefits() {
  return <section id="beneficios" className="py-24 bg-white relative overflow-hidden" data-id="element-35">
      {/* Subtle cyan gradient background */}
      <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white via-white to-brand-cyan/5 pointer-events-none" data-id="element-36" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-37">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-38">
          <div data-id="element-39">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl font-bold mb-6" data-id="element-40">
              Por qué trabajar con Nicova Digital
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-lg text-slate-600 mb-10" data-id="element-41">
              No somos una agencia tradicional. Somos tu partner tecnológico
              para escalar ventas mediante sistemas predecibles y automatizados.
            </motion.p>

            <div className="grid sm:grid-cols-2 gap-6" data-id="element-42">
              {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return <motion.div key={benefit.title} initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: index * 0.1
              }} className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-43">
                    <div className="w-12 h-12 rounded-full bg-brand-cyan/10 flex items-center justify-center mb-4" data-id="element-44">
                      <Icon size={24} className="text-brand-cyan" data-id="element-45" />
                    </div>
                    <h3 className="font-bold text-lg mb-2" data-id="element-46">{benefit.title}</h3>
                    <p className="text-sm text-slate-600" data-id="element-47">
                      {benefit.description}
                    </p>
                  </motion.div>;
            })}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative" data-id="element-48">
            <div className="aspect-square rounded-full bg-gradient-to-tr from-brand-cyan/20 to-slate-200/50 absolute -inset-4 blur-3xl -z-10" data-id="element-49" />
            <div className="bg-white rounded-3xl shadow-card border border-slate-100 p-8 relative overflow-hidden" data-id="element-50">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-cyan/10 rounded-bl-full" data-id="element-51" />

              <div className="flex items-center justify-between mb-6 relative z-10" data-id="element-52">
                <div data-id="element-53">
                  <h3 className="font-montserrat font-bold text-lg" data-id="element-54">
                    Panel de Crecimiento
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-55">
                    Resultados en tiempo real
                  </p>
                </div>
                <span className="flex items-center gap-1.5 text-xs font-semibold text-brand-cyan bg-brand-cyan/10 px-2.5 py-1 rounded-full" data-id="element-56">
                  <span className="w-1.5 h-1.5 rounded-full bg-brand-cyan animate-pulse" data-id="element-57" />
                  En vivo
                </span>
              </div>

              <div className="space-y-4 relative z-10" data-id="element-58">
                {panelItems.map((item, i) => {
                const Icon = item.icon;
                return <motion.div key={item.label} initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 0.4,
                  delay: 0.2 + i * 0.1
                }} className="flex items-center gap-4 p-4 rounded-xl bg-slate-50 border border-slate-100 hover:border-brand-cyan/30 transition-colors" data-id="element-59">
                      <div className="w-10 h-10 rounded-full bg-white shadow-sm flex items-center justify-center shrink-0" data-id="element-60">
                        <Icon size={18} className="text-brand-cyan" data-id="element-61" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-62">
                        <div className="font-semibold text-sm text-brand-black truncate" data-id="element-63">
                          {item.label}
                        </div>
                        <div className="text-xs text-slate-500 truncate" data-id="element-64">
                          {item.sublabel}
                        </div>
                      </div>
                      <div className="text-brand-cyan font-bold text-lg shrink-0" data-id="element-65">
                        {item.value}
                      </div>
                    </motion.div>;
              })}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}